import React, { ReactNode } from 'react';
import { Tooltip } from 'modules/ui';

import styles from './FormLabel.module.scss';

type FormLabelProps = Omit<React.ComponentProps<'label'>, 'children'> & {
    children?: ReactNode;
};

export const FormLabel = ({ children, ...props }: FormLabelProps) => {
    // A field with only a placeholder passes no label. Rendering the element anyway leaves an empty
    // flex item in FormField, and its gap then shows up as dead space above the input — so drop it,
    // the way FormError drops itself when there is no message.
    if (!children) return null;

    return (
        // Ensure tooltip is displayed for truncated labels
        // (e.g., "Customer ad..." showing full label "Customer address")
        <Tooltip content={children} align="center">
            <label className={styles.label} {...props}>
                {children}
            </label>
        </Tooltip>
    );
};
